import { render, staticRenderFns } from "./NormalSearchNav518.vue?vue&type=template&id=36b4b731&scoped=true"
import script from "./NormalSearchNav518.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav518.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b4b731",
  null
  
)

export default component.exports